import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { AsyncData } from '@cigna/shared/angular/core/interfaces-util';
import { FormularyPartialState } from './formulary.reducer';

import * as FormularySelectors from './formulary.selectors';
import { loadFormulary } from './formulary.actions';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormularyRequest } from './formulary.models';

@Injectable()
export class FormularyFacade {
  formularyDrugList$ = combineLatest([
    this.store$.select(FormularySelectors.getFormularyLoaded),
    this.store$.select(FormularySelectors.getFormularyDrugList),
    this.store$.select(FormularySelectors.getFormularyError),
  ]).pipe(map(([loaded, data, error]) => new AsyncData(loaded, data, error)));

  otherInformations$ = this.store$.pipe(
    select(FormularySelectors.getOtherInformation),
  );

  constructor(private store$: Store<FormularyPartialState>) {}

  public loadFormularyDrugList(
    formularyRequest: FormularyRequest,
    isPublic: boolean,
    loadMore: boolean,
  ) {
    this.store$.dispatch(
      loadFormulary({ formularyRequest, isPublic, loadMore }),
    );
  }
}
